var map = {
	"./hat_Accursed Mask.png": 2726,
	"./hat_Frankenstein.png": 3110,
	"./hat_Monkey Jpeg Mask.png": 4402,
	"./hat_Mummy Mask.png": 2956,
	"./hat_Pumpkin.png": 625,
	"./hat_SK Mask.png": 3230,
	"./hat_Witch's Hat.png": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8319;